import type { TeamMember } from "@don/wire";

import { editFailedCopy, editForm, editTitle } from "./edit.js";
import type { TeamSource } from "./team.js";
import { TeammateDialog } from "./TeammateDialog.js";

/**
 * Edit (epic 26-10-02-knowledge-v0, issue 216; ux-spec decision 20, design-spec §5
 * `edit-form`, `save-busy`): the Add form prefilled from the row (`editForm`), titled "Edit
 * {Full name}", Save / Saving…. Focusing the prefilled Name leaves the caret at its end, which
 * is the browser's own placement (`settings.spec.ts` asserts it). Changing Works in shows no
 * note under it (owner removed it 2026-10-05). A failed save names the person as the row did.
 *
 * `onEdited` is called with the server's row; the page folds it in, where it sorts by name.
 */
export function EditTeammateDialog({
  member, edit, onEdited, onClose,
}: {
  member: TeamMember;
  edit: TeamSource["edit"];
  onEdited: (person: TeamMember) => void;
  onClose: () => void;
}) {
  return (
    <TeammateDialog
      kind="edit"
      title={editTitle(member)}
      initial={editForm(member)}
      submitLabel="Save"
      busyLabel="Saving…"
      failedCopy={() => editFailedCopy(member)}
      send={async (request) => {
        const outcome = await edit(member.person_id, request);
        if (outcome.outcome !== "edited") return "email_on_team";
        onEdited(outcome.person);
        return "done";
      }}
      onClose={onClose}
    />
  );
}
